import gql from 'graphql-tag'

export const QUERY_GET_PICKING_FEED = gql`query getAuditOrder($size: Int, $sort: [SortInput], $filters: [FilterInput], $range: [RangeInput]) {
    getAuditOrder(size: $size, sort: $sort, filters: $filters, range: $range) {
      count
      page
      results {
        ... on PickingProcess {
          foundRate
          bipicking
          ordersBipicking
          auditInfo {
            failedCount
            passedCount
            rules
            smartrules {
              reason
              subReasons  
            }
          }
          pickingTime {
            init
            end
            stats {
              init
              end
              correlative
              field
            }
          }
          orderWithLoader {
            id
            idStore
            createdAt
            isPriorityShipping
            salesChannel {
              id
              name
            }
            customer {
              isVIP
              isUltraVIP
              isCencoPrime
            }
            logisticsInfo {
              selectedSla
              shippingEstimateDate
              shippingEstimate
              deliveryWindow {
                price
                startDateUtc
                endDateUtc
              }
              shippingETA
              shippingETAend
            }
          }
          pickerWithLoader {
            id
            firstName
            lastName
          }
          status {
            label
            code
          }
        }
      }
    }
  }
`;

